// src/pages/ConteoAccesoPage.js
import React, { useContext, useState, useEffect, useRef } from "react";
import { DataContext } from "../context/DataContext";
import { agruparAccesoPorRango, obtenerCursosSinDocente } from "../utils/dataUtils";
import SearchableSelect from "../components/SearchableSelect";
import StackedAcceso from "../components/StackedAcceso";
import "../styles/pages.css";
import { FaClipboardList, FaChartBar } from "react-icons/fa";
import Loader from "../components/Loader";
import useInternalLoader from "../hooks/useInternalLoader";
import { limpiarNombreColegio } from "../utils/stringUtils";
import ExportCSVButton from "../components/ExportCSVButton";
import { generatePDF } from "../components/ExportPDFButton";
import html2canvas from "html2canvas";

const ConteoAccesoPage = () => {
  const { data, loadingData, errorData, loadData, collegeName } = useContext(DataContext);
  const { internalLoading, runWithLoader } = useInternalLoader();
  const nombreColegioLimpio = collegeName ? limpiarNombreColegio(collegeName) : "Mi Colegio";

  const [rolSeleccionado, setRolSeleccionado] = useState("todos");
  const [cursoSeleccionado, setCursoSeleccionado] = useState("");
  const [yearSeleccionado, setYearSeleccionado] = useState("");
  const [cursosDisponibles, setCursosDisponibles] = useState([]);
  const [dataAgrupada, setDataAgrupada] = useState([]);

  const refStacked = useRef();

  useEffect(() => {
    if (data && data.length > 0) {
      const cursos = obtenerCursosSinDocente(data);
      setCursosDisponibles(cursos);
      if (cursoSeleccionado && !cursos.includes(cursoSeleccionado)) {
        setCursoSeleccionado("");
      }
    }
  }, [data, cursoSeleccionado]);

  useEffect(() => {
    if (data && data.length > 0) {
      runWithLoader(async () => {
        let filtrados = data;
        if (rolSeleccionado === "teacher") {
          filtrados = filtrados.filter((d) => d.role_shortname === "teacher");
        } else if (rolSeleccionado === "student") {
          filtrados = filtrados.filter((d) => d.role_shortname === "student");
        }
        if (cursoSeleccionado) {
          filtrados = filtrados.filter((d) => d.course_fullname === cursoSeleccionado);
        }
        const agrupados = agruparAccesoPorRango(filtrados, yearSeleccionado);
        setDataAgrupada(agrupados);
      });
    }
  }, [data, rolSeleccionado, cursoSeleccionado, yearSeleccionado, runWithLoader]);

  if (loadingData) {
    return (
      <div className="loading-container">
        <h2>Cargando datos...</h2>
        <div className="loader"></div>
      </div>
    );
  }
  if (errorData) {
    return (
      <div className="loading-container">
        <h2 className="error-text">Error al cargar datos</h2>
        <p>{errorData.message}</p>
        <button onClick={loadData} className="btn-primary" style={{ marginTop: 10 }}>
          Reintentar
        </button>
      </div>
    );
  }
  if (internalLoading) {
    return <Loader />;
  }

  const csvHeaders = [
    { label: "Mes", key: "mes" },
    { label: "Sin minutos", key: "Sin minutos" },
    { label: "1 a 10 minutos", key: "1 a 10 minutos" },
    { label: "10 a 40 minutos", key: "10 a 40 minutos" },
    { label: "Más de 40 minutos", key: "más de 40 minutos" },
  ];

  const handleExportPDF = async () => {
    const stackedImg = refStacked.current ? await html2canvas(refStacked.current).then((c) => c.toDataURL()) : null;
    generatePDF({
      data: dataAgrupada,
      headers: csvHeaders,
      filename: "reporte_conteo.pdf",
      chartImages: [stackedImg],
    });
  };

  return (
    <div className="page-container">
      <h1 className="page-title">{nombreColegioLimpio} (Conteo de Acceso)</h1>

      <div className="page-card">
        <div className="page-card-header">
          <FaClipboardList />
          <span>Filtros</span>
        </div>
        <div className="page-card-body">
          <div className="filter-group">
            <div className="filter-item">
              <SearchableSelect
                label="Año"
                options={Array.from(new Set(data.map((d) => new Date(d.event_date).getFullYear().toString())))}
                value={yearSeleccionado}
                onChange={setYearSeleccionado}
              />
            </div>
            <div className="filter-item">
              <label>Rol:</label>
              <select
                className="custom-select"
                value={rolSeleccionado}
                onChange={(e) => setRolSeleccionado(e.target.value)}
              >
                <option value="todos">Todos</option>
                <option value="teacher">Profesores</option>
                <option value="student">Estudiantes</option>
              </select>
            </div>
            <div className="filter-item">
              <SearchableSelect
                label="Curso"
                options={cursosDisponibles}
                value={cursoSeleccionado}
                onChange={setCursoSeleccionado}
              />
            </div>
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center", marginBottom: 20, display: "flex", justifyContent: "center", gap: 10 }}>
        <ExportCSVButton
          data={dataAgrupada}
          filename="reporte_conteo.csv"
          headers={csvHeaders}
          separator=";"
        />
        <button onClick={handleExportPDF} className="btn-primary">
          Exportar PDF
        </button>
      </div>

      <div className="page-card">
        <div className="page-card-header">
          <FaChartBar />
          <span>Accesos por Rango</span>
        </div>
        <div className="page-card-body" ref={refStacked}>
          <StackedAcceso data={dataAgrupada} />
        </div>
      </div>
    </div>
  );
};

export default ConteoAccesoPage;
